export default __webpack_public_path__ + "static/starbucks.url-9e231d4076c88c8d836f9e36e6eef3a0.svg";